import { takeLatest } from 'redux-saga/effects';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/forgetPasswordTypes';
import { encryptData } from '../../../utils/encryptDecryptUtility';

export function* forgetPasswordSaga(data: any): Generator {

  const sendRequest = SendRequest.instance;
  const { payload: { key, emailValue, cnfrmPassword, tokenAvailable, userName, pwdToken, otp, onSuccess, onError } } = data;
  const encryptedUserName = encryptData(userName);
  const encryptedValue = key === 'userName' ? encryptData(emailValue) : emailValue;
  const requestJSON = !tokenAvailable ? {
    [key === 'userName' ? 'encryptedUserName' : key]: encryptedValue,
    tokenAvailable: false,
  } : {
    pwdToken,
    encryptedPassword: encryptData(cnfrmPassword),
    tokenAvailable,
    encryptedUserName,
    otp,
  };
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/ResetPassword`;

  try {
    const response: any = yield sendRequest.post<any, any>(url, requestJSON, { isShowErrorInInterceptor: false });
    const { isSuccess, errorMessage } = response;
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    console.error(e);
    onError();
  }
}

export function* watchForgetPasswordAction(): any {
  yield takeLatest(actionTypes.FORGET_PASSWORD, forgetPasswordSaga);
}

export default watchForgetPasswordAction;
